/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Notify,AddressbarColor,Cookies,Meta,Dialog,BottomSheet,LocalStorage,Loading,AppFullscreen,Dark} from 'quasar'



export default { config: {"notify":{"multiline":true,"timeout":10000,"textColor":"black"},"dark":"auto"},plugins: {Notify,AddressbarColor,Cookies,Meta,Dialog,BottomSheet,LocalStorage,Loading,AppFullscreen,Dark} }

